<template>
  <v-menu open-on-hover right content-class="caption-content" :close-on-content-click="false" attach="#caption" >
    <template v-slot:activator="{ on:sliderOn }">
         <v-tooltip top>
        <template v-slot:activator="{ on:tooltipOn }">
            <v-btn
            id="caption" 
            class="media-control-button media-caption"
            v-on="{...tooltipOn,...sliderOn}"
            @click="onCaptionToggle"
            >
            <v-icon v-show="defaultIsCaption">{{localIcons['mdi-closed-caption']}}</v-icon>
            <v-icon v-show="!defaultIsCaption">{{localIcons['mdi-closed-caption-outline']}}</v-icon>
            </v-btn>
        </template>
    </v-tooltip>

    </template>

        <div class="caption-tooltip" v-html="defaultIsCaption ? $lang.share.captions_overlay_on : $lang.share.captions_overlay_off"></div>
           <v-slider
          ref="captionslider"
          v-model="position"
          class="caption-slider custom-slider"
          @click.stop.prevent=""
          @mousedown.stop.prevent=""
          :max="0.93"
          :min="0"
          :step="0.01"
          color="#20f7c4"
          height="auto"
        ></v-slider>
  </v-menu>
</template>

<script>
import { mdiClosedCaption, mdiClosedCaptionOutline} from '@mdi/js'
export default {
  props: ['defaultPosition', 'defaultIsCaption'],
  components: {},
  data () {
    return {
      position: 0,
      localIcons:{
        'mdi-closed-caption':mdiClosedCaption,
        'mdi-closed-caption-outline': mdiClosedCaptionOutline
      }
    }
  },
  name: 'play-back-speed-button',
  watch: {
    position (newVal) {
      this.$emit('change', newVal)
    },
  },
  methods:{
    onCaptionToggle(newVal){
      this.$emit('toggle', newVal)
    }
  },
  mounted () {
    const me = this;
    me.position = me.defaultPosition
  }
}
</script>

<style>
.caption-content {
  width: 165px;
  min-width: 165px!important;
   top: -52px!important;
  background: transparent;
  box-shadow: none;
  border-radius: 0px;
  -webkit-box-shadow: none;
  left:40px!important;
  overflow: visible;
}
.caption-content .v-slider--horizontal{
 min-height:28px!important;
}
.caption-content .row {
  margin: 0px;
}

.spcaptioneed-content .col {
  padding: 0px;
}

.caption-content .col .row {
  height: 33%;
  font-size: 12px;
  color: #0062ff;
  user-select: none;
}
.caption-content .top {
  align-items: flex-start;
}
.caption-content .mid {
  padding-top: 30px;
  align-items: center;
}
.caption-content .bottom {
  align-items: flex-end;
}

.caption-content .v-input__slot{
  background: black;
}
.caption-tooltip{
    background:rgba(97, 97, 97, 0.9);
    padding:5px;
    border-radius: 4px;
    font-weight: 100px;
}
.caption-tooltip>span{
    font-size:12px;

}
.media-control-button.media-caption{
  z-index:1;
}
</style>
